import { connect } from 'react-redux'
import DocHub from './DocHub';


const mapStateToProps = ( state ) => {
    return {
        packages : state.docList || []
    }
};


const mapDispatchToProps = ( dispatch ) => {
    return {
        updateDocList : ( packageFilter = null, type = null, channel = null, signature = null ) => {
            return dispatch(
                {
                    type    : 'DOC_LIST_REQUESTED',
                    opts    : { packageFilter, type, channel, signature }
                }
            );
        }
    };
};


const ReduxDocHub = connect(
    mapStateToProps,
    mapDispatchToProps
)( DocHub );


export default ReduxDocHub;



// WEBPACK FOOTER //
// ./src/lib/components/DocHub/index.js